'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.directive('elementInit', function () {
    return {
      restrict: 'A',
      link: function link($scope, $element, $attr) {
        $attr.elementInit && $scope.$eval($attr.elementInit)($element[0]);
      }
    };
  });
  return app;
};

require('angular');

/**
 * element init
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/directives/elementInit.js
// module id = 142
// module chunks = 0